module.exports = __webpack_public_path__ + "static/img/thumbnail.c358402.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mypage/thumbnail.svg
// module id = kVya
// module chunks = 1